<template>
  <div class="d-content">
    <!-- <dashboard-content-nav :nav="navItems" /> -->
    <keep-alive>
      <component :is="currentComponent" :entity_index="entity_index"></component>
    </keep-alive>
  </div>
</template>
<script>
  import dashboardContentNav from "@/components/dashboard/contentNav.vue";

  //Pages
  import changePasswordUser from "./changePasswordUser.vue";
  
  const mapNameToComponents = {
    changePasswordUser: changePasswordUser,
  };

  const getPathForStep = (entity_index,step_name, sub_step) => {
    if (sub_step) {
      return `/dashboard/${entity_index}/organisation/${step_name}/${sub_step}`;
    } else {
      return `/dashboard/${entity_index}/organisation/${step_name}`;
    }
  };

  const nav_items = (entity_index) => [ 
    // {
    //   type: "navitem",
    //   label: "Offers",
    //   path: getPathForStep(entity_index,"offers"),
    //   icon: "reports"
    // },
    {
      type: "navitem",
      label: "Utilities",
      path: getPathForStep(entity_index,"utilities"),
      icon: "settings-1",
      children: [
        {
          path: getPathForStep(entity_index,"utilities", "voluntaryPf")
        },
        {
          path: getPathForStep(entity_index,"utilities", "smtp")
        },
        {
          path: getPathForStep(entity_index,"utilities", "manage_financial_year")
        },
        {
          path: getPathForStep(entity_index,"utilities", "download_payslips")
        },
        {
          path: getPathForStep(entity_index,"utilities", "salarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "editsalarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "addsalarycomponent")
        },
        {
          path: getPathForStep(entity_index,"utilities", "essLogin")
        },
        {
          path: getPathForStep(entity_index,"utilities", "retirementsettings")
        },
        {
          path: getPathForStep(entity_index,'utilities', 'ITdeclarations')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'editdeclaration')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'importdeclarations')
        },
        {
          path: getPathForStep(entity_index,'utilities', 'exportdeclarations')
        },
        {
          path: getPathForStep(entity_index,"utilities", "addLeaveInputs")
        },
        {
          path: getPathForStep(entity_index,"utilities", "changeemployeemasterfieldsbulk")
        },
        {
          path: getPathForStep(entity_index,"utilities", "downloaduploadmastertemplate")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form24q")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form16")
        },
        {
          path: getPathForStep(entity_index,"utilities", "resetPassword")
        },
        {
          path: getPathForStep(entity_index,"utilities", "loan_details")
        },
        {
          path: getPathForStep(entity_index,"utilities", "passwordPolicy")
        },
        {
          path: getPathForStep(entity_index,"utilities", "loanpaymentsummary")
        },
        {
          path: getPathForStep(entity_index,"utilities", "changeemployeemasterfieldsbulk")
        },
        {
          path: getPathForStep(entity_index,"utilities", "downloaduploadmastertemplate")
        },
        {
          path: getPathForStep(entity_index,"utilities", "fbpsettingsandcomponentmapping")
        },
        {
          path: getPathForStep(entity_index,"utilities", "legacydata")
        },
        {
          path: getPathForStep(entity_index,"utilities", "form_annexure")
        }
        /*
        {
          path: getPathForStep("utilities", "assignperk"),
          children: [
            {
              path: getPathForStep("utilities", "processfnf")
            }
          ]
        {
          path: getPathForStep("utilities", "policyDocument")
        }
        */
      ]
    }
  ];

  export default {
    components: {
      dashboardContentNav
    },
    props: ["step_name", "sub_step", "sub_step_name",'entity_index'],
    data() {
      return {
        navItems: []
      };
    },
    methods: {
      contentShow(event) {
        var sections = document.querySelectorAll(".d-payroll__accordBlock");
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove("active");
        }
        event.target.parentNode.classList.toggle("active");
      }
    },
    created() {
      this.navItems = nav_items(this.entity_index);
    },
    computed: {
      currentComponent: function () {
        if (this.sub_step_name) {
          return mapNameToComponents[this.sub_step_name];
        } else {
          return mapNameToComponents[this.sub_step];
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "@/scss/dashboard/_variables.scss"; // Common
  @import "@/scss/dashboard/content/_section.scss"; // Content Section
</style>